var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentLedger(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33333 2.66667H9.33333V4H5.33333V2.66667ZM5.33333 5.33333H9.33333V6.66667H5.33333V5.33333ZM5.33333 8H9.33333V9.33333H5.33333V8ZM2.66667 2.66667H4V4H2.66667V2.66667ZM2.66667 5.33333H4V6.66667H2.66667V5.33333ZM2.66667 8H4V9.33333H2.66667V8ZM11.4 0H0.6C0.266667 0 0 0.266667 0 0.6V11.4C0 11.6667 0.266667 12 0.6 12H11.4C11.6667 12 12 11.6667 12 11.4V0.6C12 0.266667 11.6667 0 11.4 0ZM10.6667 10.6667H1.33333V1.33333H10.6667V10.6667Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLedger);
export default __webpack_public_path__ + "static/media/payment-ledger.9bcd115929841bf731873e2e510e282a.svg";
export { ForwardRef as ReactComponent };